import React, { useState, useEffect } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { useNavigate, useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'
import icolinkedin from '../assets/ico-linkedin.svg'
import icotwitter from '../assets/ico-twitter.svg'
import icofacebook from '../assets/ico-facebook.svg'
import icowhatsapp from '../assets/ico-whatsapp.svg'
import quoteico from '../assets/quote-ico.svg'
import back from '../assets/back.svg'
import { useVideos } from '../hooks/useVideos'
import { useTags } from '../hooks/useTags'
import { SERVER_URL } from '../utils'
import CustomHelmet from '../components/seo/CustomHelmet'
import { useLang } from '../translations/i18n'
import { RUTAS } from '../constants/routes.constants'
import TranslatedLink from '../components/navigation/TranslatedLink'
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import ReactPlayer from 'react-player'

const TranscriptionElem = ({ minute, text }) => {
	return (
		<div className="row mt-5">
			<div className="col-12 col-lg-1 text-start text-lg-center">{minute}</div>
			<div className="col-12 col-lg-11">{text}</div>
		</div>
	)
}

const OtherElem = ({ tags, summary, image, duration, id }) => {
	const lang = useLang()
	return (
		<div className="col-12 col-lg-4">
			<Link
				to={RUTAS.VIDEO[lang].replace(':name', summary)}
				state={id}
			>
				<img src={`${SERVER_URL}/${image}`} alt="video" className="img-fluid imgrelated" />
				<div className="redlineright2">
					<div className="fontmedium">{tags}</div>
					<div className="fontbook d-block d-lg-none my-1">{duration}</div>
					<p>{summary}</p>
					<div className="fontbook d-none d-lg-block">{duration}</div>
				</div>
			</Link>
		</div>
	)
}

function Video({ intl }) {
	const [dataTags, setDataTags] = useState([])
	const [data, setData] = useState([])
	const [dataVideos, setDataVideos] = useState([])
	const location = useLocation()
	const navigate = useNavigate()
	//const [showVideo, setShowVideo] = useState(false)
	const { handleFetchVideo, handleFetchVideoURL } = useVideos()
	const { handleFetchVideosByTag } = useVideos()
	const { handleFetchTags } = useTags()

	const lang = useLang()

	useEffect(() => {
		localStorage.setItem('seoURL', JSON.stringify(data?.seoURL || {}))
	}, [data?.seoURL])

	const id = location.state || null

	/*function handleClick(e) {
		setShowVideo(true)
	}*/

	function playVideo(){
		console.log('play video');
		window.dataLayer.push({'event': 'on click video'})
	}

	useEffect(() => {
		setTimeout(() => window.scrollTo(0, 0), 250)
		const asyncFetch = async () => {
			let { data, error } = await handleFetchVideo({ id: id })
			if (error){
				const { data: data2, error: error2 } = await handleFetchVideoURL({ url: location.pathname.split('/').pop() })
				if (error2){
					navigate("/404")
					//navigate(RUTAS.VIDEOS[lang])
					return
				}
				data = data2
			}
			data.urlYoutube = 'https://www.youtube.com/embed/'+data.idyoutube[lang]+'?feature=oembed&enablejsapi=1'
			setData(data)
		}
		const asyncFetchTags = async () => {
			const dataTags = await handleFetchTags({ })
			setDataTags(dataTags)
		}

		asyncFetch()
		asyncFetchTags()
		// eslint-disable-next-line
	}, [location?.pathname])

	useEffect(() => {
		if (!data.tags)
			return

		const asyncFetchVideos = async () => {
			const dataVideos = await handleFetchVideosByTag({ tags: data.tags })
			setDataVideos(dataVideos)
		}
		asyncFetchVideos()
		// eslint-disable-next-line
	}, [data?.tags, location?.pathname])

	let transcription = ''
	if (data?.transcriptions && Object.keys(data?.transcriptions).length !== 0)
		transcription = <div className="row my-5">
			<div className="col-12 text-center my-3">
				<h2><FormattedMessage id='VIDEO.TRANSCRIPCION' /></h2>
			</div>
			<div className="col-12">
				<div className="transcriptions px-2">
					{data?.transcriptions && data?.transcriptions[lang]?.map(elem =>
						<TranscriptionElem
							minute={elem.minute}
							text={elem.text}
						/>
					)}
				</div>
			</div>
		</div>

	return (
		<>
			<CustomHelmet
				title={(data?.seotitle && data?.seotitle[lang]) || ''}
				description={(data?.seodescription && data?.seodescription[lang]) || ''}
			/>
			<div className="container-fluid px-3 px-lg-5">
				<div className="row">
					<div className="col-12"><TranslatedLink to={RUTAS.VIDEOS} className="volver"><img src={back} alt="back-button" className="backbutton"/><FormattedMessage id='VIDEO.VOLVER' /></TranslatedLink></div>
				</div>
				<div className="row my-3">
					<div className="col-12">
						<div className="ratio ratio-21x9">
							<ReactPlayer
								width='100%'
								height='100%'
								controls={true}
								onStart={() => playVideo()}
								url={data.urlYoutube} />
						</div>
					</div>
				</div>
				<div className="row mt-5">
					<div className="col-11">
						<h1>{data.summary && data.summary[lang]}</h1>
						<div className="d-flex flex-row quote my-4">
							<div><img src={quoteico} alt="quote" className="quoteico" /></div>
							<div><span className="quotetxt">{data.quote && data.quote[lang]}</span></div>
						</div>
						{data.content && <p dangerouslySetInnerHTML={{ __html: data.content[lang] }}></p>}
					</div>
					<div className="col-1 text-center redline redlineactive">
						<div>
							<TwitterShareButton
								url={window.location.href}
								title={(data.summary && data.summary[lang]) || 'Video Hubdigital'}
							>
								<img src={icotwitter} alt="Twitter" className="icovert my-3"/>
							</TwitterShareButton>
						</div>
						<div>
							<FacebookShareButton
								url={window.location.href}
								quote={(data.summary && data.summary[lang]) || 'Video Hubdigital'}
							>
								<img src={icofacebook} alt="Facebook" className="icovert my-3"/>
							</FacebookShareButton>
						</div>
						<div>
							<LinkedinShareButton
								url={window.location.href}
								title={(data.summary && data.summary[lang]) || 'Video Hubdigital'}
								summary={(data.summary && data.summary[lang]) || 'Video Hubdigital'}
							>
								<img src={icolinkedin} alt="Linkedin" className="icovert my-3"/>
							</LinkedinShareButton>
						</div>
						<div>
							<WhatsappShareButton
								url={window.location.href}
								title={(data.summary && data.summary[lang]) || 'Video Hubdigital'}
							>
								<img src={icowhatsapp} alt="Whatsapp" className="icovert my-3" style={{ 'width':'20px' }}/>
							</WhatsappShareButton>
						</div>
						{/* <div><Link to="/"><img src={icotwitter} alt="Twitter" className="icovert my-3"/></Link></div> */}
						{/* <div><Link to="/"><img src={icofacebook} alt="Facebook" className="icovert my-3"/></Link></div> */}
						{/* <div><Link to="/"><img src={icolinkedin} alt="Linkedin" className="icovert my-3"/></Link></div> */}
						{/* <div><a href={clsx('https://api.whatsapp.com/send?text=', data.summary && data.summary[lang])} target="_blank" data-action="share/whatsapp/share" rel="noreferrer"><img src={icowhatsapp} alt="Whatsapp" className="icovert my-3" style={{ 'width':'20px' }}/></a></div> */}
					</div>
				</div>
				{transcription}
				<div className="row my-5">
					<div className="col-12 text-center">
						<h2><FormattedMessage id='VIDEO.TAMBIEN' /></h2>
					</div>
				</div>
				<div className="row mb-5">
					<div className="col-12">
						<div className="alsointeresting px-0 px-lg-2">
							<div className="row my-3 mb-5">
								{dataVideos?.filter(video => video._id !== data._id)
								.slice(0, 3)
								.map(elem =>
									<OtherElem
										tags={elem.tags.map((elem) => {
											return (
												dataTags?.find(cat => cat._id === elem)?.fullName[lang] || '---'
											)
										}).join(' | ')}
										image={elem.image}
										summary={elem.summary && elem.summary[lang]}
										duration={elem.duration[lang]}
										id={elem._id}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default injectIntl(Video)
